import React, {Fragment, useEffect, useState} from 'react';
import {CONSTANT_CONFIG} from "../../../constants";
import {Spin} from "antd";
import {ImageNotFound} from "../../../assets/images/placeholder";

export enum IMAGE_LOAD_STATUS { LOADING, SUCCESS, ERROR}

interface IProps {
    imageId: string;
    alt?: string;
    width?: string;
    height?: string;
    style?:object,
    className?:string,
    showLoading?: boolean;
    showNotFoundImage?: boolean;
    [key: string]: any,
}

const CdnImage: React.FC<IProps> = props => {
    const { imageId, alt = '', showLoading = false, showNotFoundImage = false, ...restProps } = props;
    const [imageSrc, setImageSrc] = useState('');
    const [imageLoadedStatus, setImageLoadedStatus] = useState(IMAGE_LOAD_STATUS.LOADING);

    useEffect(() => {
        setImageLoadedStatus(IMAGE_LOAD_STATUS.LOADING);

        if (imageId === "" || imageId === null ||  imageId === undefined) {
            setImageSrc('');
            setImageLoadedStatus(IMAGE_LOAD_STATUS.ERROR)
        }
        else {
            try {
                const img = new Image()
                const imgUrl = CONSTANT_CONFIG.CDN_URL + 'image/' + imageId;

                img.src = imgUrl
                img.onload = () => {
                    setImageSrc(imgUrl);
                    setImageLoadedStatus(IMAGE_LOAD_STATUS.SUCCESS)
                    img.remove()
                }
                img.onerror = () => {
                    setImageSrc('');
                    setImageLoadedStatus(IMAGE_LOAD_STATUS.ERROR)
                    img.remove()
                }
            }
            catch {
                setImageSrc('');
                setImageLoadedStatus(IMAGE_LOAD_STATUS.ERROR)
            }
        }

    }, [imageId])

    return (
        <>
            {showLoading && imageLoadedStatus === IMAGE_LOAD_STATUS.LOADING && (
                <Spin size="small" />
            )}

            {showNotFoundImage && imageLoadedStatus === IMAGE_LOAD_STATUS.ERROR && (
                <img src={ImageNotFound} alt={alt} {...restProps} />
            )}

            {imageLoadedStatus === IMAGE_LOAD_STATUS.SUCCESS && (
                <img src={imageSrc} alt={alt} {...restProps} />
            )}
        </>
    );
}

export default React.memo(CdnImage);